import React, { useEffect, useState } from 'react';
import { Button, Card, Descriptions, Space, Tag, message, Popconfirm, Avatar } from 'antd';
import { ArrowLeftOutlined, EditOutlined, MergeCellsOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import RpEntityMergeModal from '../../components/RpEntityMergeModal/RpEntityMergeModal';

const AnimationNpcDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [npc, setNpc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mergeOpen, setMergeOpen] = useState(false);

  const fetchNpc = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/api/admin/animation-npcs/${id}`);
      setNpc(response.data);
    } catch (error) {
      message.error('Erreur lors du chargement');
      navigate('/animation-npcs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNpc();
  }, [id]);

  const handleAbandon = async () => {
    try {
      await api.delete(`/api/admin/animation-npcs/${id}`);
      message.success('PNJ abandonné');
      navigate('/animation-npcs');
    } catch (error) {
      message.error(error.response?.data?.error || 'Erreur');
    }
  };

  const handleMerged = (result) => {
    if (result?.survivorType === 'npc' && String(result.survivorId) !== String(id)) {
      navigate(`/animation-npcs/detail/${result.survivorId}`);
      return;
    }
    if (result?.survivorType === 'character') {
      navigate(`/characters/detail/${result.survivorId}`);
      return;
    }
    fetchNpc();
  };

  if (loading || !npc) {
    return <Card loading={loading}>Chargement...</Card>;
  }

  return (
    <>
      <Card
        title={npc.name}
        extra={(
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/animation-npcs')}>
              Retour
            </Button>
            <Button icon={<EditOutlined />} onClick={() => navigate(`/animation-npcs/edit/${id}`)}>
              Modifier
            </Button>
            <Button icon={<MergeCellsOutlined />} onClick={() => setMergeOpen(true)}>
              Fusionner
            </Button>
            <Popconfirm title="Abandonner ce PNJ ?" onConfirm={handleAbandon}>
              <Button danger>Abandonner</Button>
            </Popconfirm>
          </Space>
        )}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Avatar
            src={npc.avatar}
            size={120}
            icon={<UserOutlined />}
          />
        </div>
        <Descriptions bordered column={1}>
          <Descriptions.Item label="Univers">{npc.universe_name}</Descriptions.Item>
          <Descriptions.Item label="Statut"><Tag color="green">{npc.status}</Tag></Descriptions.Item>
          <Descriptions.Item label="Occupation">{npc.occupation || '—'}</Descriptions.Item>
          <Descriptions.Item label="Biographie">{npc.biography || '—'}</Descriptions.Item>
          <Descriptions.Item label="Personnalité">{npc.personality || '—'}</Descriptions.Item>
          <Descriptions.Item label="Style de dialogue">{npc.dialogueStyle || '—'}</Descriptions.Item>
          <Descriptions.Item label="Capacités">{npc.abilities || '—'}</Descriptions.Item>
          <Descriptions.Item label="Secrets">{npc.secrets || '—'}</Descriptions.Item>
          <Descriptions.Item label="Créé par">{npc.created_by_pseudo || '—'}</Descriptions.Item>
        </Descriptions>
      </Card>

      <RpEntityMergeModal
        open={mergeOpen}
        entity={{ id: npc.id, type: 'npc', name: npc.name, universe_id: npc.universe_id }}
        onClose={() => setMergeOpen(false)}
        onMerged={handleMerged}
      />
    </>
  );
};

export default AnimationNpcDetail;
